<template>
    <div>
        <a-modal title="执行一次" :visible="modalState.visible" :confirm-loading="confirmLoading" width="400px"
            @cancel="handleCancel">
            <a-form-model :model="modalState" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="url" label="机器地址" prop="url">
                    <a-input v-model="addressList" type="textarea" aria-placeholder="请输入本次执行的机器地址，为空则从执行器获取" @blur="
                        () => {
                            $refs.url.onFieldBlur();
                        }
                        " />
                </a-form-model-item>

            </a-form-model>
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
                    保存
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>

export default {
    data() {
        return {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            rules: {
                name: [
                    { required: true, message: '请填写菜单名', trigger: 'blur' },
                ],
            },
            addressList:'',
            confirmLoading: false,
            formItemLayout:'inline',
            modalState:{
                visible:false,
            }
        };
    },
    computed: {

    },
    props:{
        
    },
    methods: {
        onModalInit(item){
            let that = this;
            that.modalState = {
                visible:true,
                ...item
            }
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(that.modalState);
                    that.confirmLoading = true;
                    if(that.modalState.id){
                        //执行一次
                        that.$store
                            .dispatch({
                                type: "jobcenter/trigger",
                                params:{
                                    id:that.modalState.id,
                                    executorParam:that.modalState.executorParam,
                                    addressList:that.addressList
                                }
                            })
                            .then((response) => {
                                that.confirmLoading = false;
                                if (response.data.code == 200) {
                                    that.handleCancel()
                                    that.message.success('执行一次成功')
                                } else {
                                    that.message.error(response.data.msg || '执行一次失败')
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.modalState.visible = false;
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    width:100%;
}
</style>
